<div class="box-table">
	<span class="title-accordion" [class.active]="!isCollapsed" (click)="isCollapsed = !isCollapsed"
		(keypress)="isCollapsed = !isCollapsed">
		{{ labels().WEDGE_TABLE_COMPONENT_TITLE }}
		<div class="fake-material-icon icon-expand expand"></div>
	</span>
	<table class="table" [ngbCollapse]="isCollapsed">
		<thead>
			<tr>
				<th></th>
				@if (hasAP) { <th>{{ labels().WEDGE_TABLE_COMPONENT_AP_HEADER }}</th> }
				@if (hasLT) { <th>{{ labels().WEDGE_TABLE_COMPONENT_LT_HEADER }}</th> }
			</tr>
		</thead>
		<tbody>
			<tr id="wedgeAngle">
				<td>{{ labels().WEDGE_TABLE_COMPONENT_WEDGE_ANGLE }}</td>
				@if (hasAP) { <td>{{ ap_wedgeAngle }}</td> }
				@if (hasLT) { <td>{{ lt_wedgeAngle }}</td> }
			</tr>
			<tr id="cortexLength">
				<td>{{ labels().WEDGE_TABLE_COMPONENT_CORTEX_LENGTH }}</td>
				@if (hasAP) { <td>{{ ap_cortexLength }}</td> }
				@if (hasLT) { <td>{{ lt_cortexLength }}</td> }
			</tr>
			<tr id="axialLength">
				<td>{{ labels().WEDGE_TABLE_COMPONENT_AXIAL_LENGTH }}</td>
				@if (hasAP) { <td>{{ ap_axialLength }}</td> }
				@if (hasLT) { <td>{{ lt_axialLength }}</td> }
			</tr>
			<tr id="secondaryTranslation">
				<td>{{ labels().WEDGE_TABLE_COMPONENT_SECONDARY_TRANSLATION }}</td>
				@if (hasAP) { <td>{{ ap_secondaryTransl }}</td> }
				@if (hasLT) { <td>{{ lt_secondaryTransl }}</td> }
			</tr>
		</tbody>
	</table>
</div>